import React from 'react'
import './index.scss'
// import { toHourMinute } from '@/utils/utils'
import CountUp from 'react-countup'
const EarnTime = (props) => {
  let { timeFrame, income, online } = props

  return (
    <div className="earn-time__box">
      <div>
        <article>
          <em><CountUp className='countUp' start={0} end={income / 100} decimals={2} duration={2} /></em>
          <span>{timeFrame}收益(元)</span>
        </article>
      </div>
      <div>
        <article>
          <em>
            <CountUp className='countUp' start={0} end={Math.floor(online / 60)} duration={3} prefix={Math.floor(online / 60) < 10 ? '0' : ''} />:
            <CountUp className='countUp' start={0} end={online % 60} duration={3} prefix={online % 60 < 10 ? '0' : ''} />
          </em>
          <span>{timeFrame}在线时长</span>
        </article>
      </div>
    </div>
  )
}
export default EarnTime
